export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-move@3x-0c2985b85952452907f639423b9bd18e.webp";